var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472.502857 1007.908571L24.868571 581.12a56.905143 56.905143 0 0 1 39.204572-98.011429h170.422857a56.905143 56.905143 0 0 0 56.905143-56.32L295.204571 56.32A56.905143 56.905143 0 0 1 352.109714 0h329.801143a56.905143 56.905143 0 0 1 56.832 57.051429l-0.731428 369.005714a56.905143 56.905143 0 0 0 56.905142 57.051428h165.010286a56.905143 56.905143 0 0 1 39.204572 98.011429L551.058286 1007.908571a56.905143 56.905143 0 0 1-78.482286 0z",
    fill: "#F5EEDC",
    stroke: "#B89F73",
    strokeWidth: 72,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f064eb8e.svg";
export { ForwardRef as ReactComponent };